import React from "react"
import { Container } from "@components"
import { Box, Flex } from "rebass"
import SingleOption from "./SingleOption"

const Content = props => (
  <Container>
    <Box mt={[1, 1, 1, 12]}>
      <Flex flexDirection={["column", "column", "row"]} justifyContent="center">
        <SingleOption
          title="Email"
          description={<a href="mailto:support@dynobase.dev">support@dynobase.dev</a>}
        />
      </Flex>
    </Box>
  </Container>
)

export default Content
